import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function VisionAndMessage() {
    return (
        <>
            <div>
                <div className="self-start text-5xl font-bold text-right text-zinc-900 max-md:max-w-full">
                    الرؤية والرسالة والقيم الأهداف
                </div>
                <div className="self-start mt-8 text-lg text-right text-zinc-900 max-md:max-w-full">
                    مؤسسة الخير تتسم بالالتزام بقيم الرحمة والعدالة الاجتماعية، وهدفها
                    الرئيسي هو تحسين حياة الناس من خلال تقديم المساعدة والتمويل في جميع
                    أنحاء العالم.
                </div>
                <div className="flex flex-col justify-center p-10 mt-11 w-full text-base font-medium leading-8 text-right bg-white rounded-2xl text-zinc-900 max-md:px-5 max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 justify-between max-md:flex-wrap max-md:max-w-full">
                        <LazyLoadImage
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/da2932255bd7cf52112660d5271f9401cb4d561f0bdeea198c45e6e54a2ba48f?apiKey=1b00d6cd98374704a0468862af744bdf&"
                            className="aspect-square w-[90px]"
                        />
                        <div className="flex-auto self-start max-md:max-w-full">
                            <span className="text-3xl font-bold">رؤيتنا</span>
                            <br />
                            <span className="text-lg">
                                تمكين الناس من العيش في مجتمعاتهم بكرامة إنسانية، وحصول الفئات
                                الضعيفة والمهمشة على حقوقها الأساسية دون تمييز.
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col justify-center p-10 mt-8 w-full text-base font-medium leading-7 text-right bg-white rounded-2xl text-zinc-900 max-md:px-5 max-md:max-w-full">
                    <div className="flex gap-5 justify-between max-md:flex-wrap max-md:max-w-full">
                        <LazyLoadImage
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/ea46303bd46a00a8611f2130179814e18f365a475164b75612668490fd7db557?apiKey=1b00d6cd98374704a0468862af744bdf&"
                            className="self-start aspect-square w-[90px]"
                        />
                        <div className="flex-auto max-md:max-w-full">
                            <span className="text-3xl font-bold">رسالتنا</span>
                            <br />
                            <span className="text-lg leading-8">
                                المساهمة في تحقيق التنمية الشاملة والمستدامة في المجتمعات الضعيفة
                                والمهمشة بما يعزز الحياة الكريمة للفئات المُستهدفة ما يجعلها قادرة
                                على تحقيق الأثر الإيجابي لنفسها ولمجتمعها.
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col justify-center p-10 mt-8 w-full text-base font-medium leading-7 text-right bg-white rounded-2xl text-zinc-900 max-md:px-5 max-md:max-w-full">
                    <div className="flex gap-5 justify-between max-md:flex-wrap max-md:max-w-full">
                        <LazyLoadImage
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/54489a7e0fd59098925f8202cfaa22d2d2fb35c1ae2e33257fd1724fdbc6dccb?apiKey=1b00d6cd98374704a0468862af744bdf&"
                            className="self-start aspect-square w-[90px]"
                        />
                        <div className="flex-auto max-md:max-w-full">
                            <span className="text-3xl font-bold">قيمنا</span>
                            <br />
                            <span className="text-lg leading-8">
                                القيم التي تمثلنا هي مجموعة القواعد الأخلاقية المنسجمة مع الفطرة
                                الإنسانية، وتمسكنا بهذه القيم هو ما يجعلنا قادرين على العمل وتقديم
                                العون للمجتمعات بكل مسؤولية من خلال:
                            </span>
                            <ul>
                                <li>
                                    <span className="text-lg font-bold leading-8">الإنسانية</span>
                                    <span className="text-lg leading-8">
                                        : أينما كان الإنسان كانت مؤسسة الخير، فنحن الخير لكل الناس.
                                    </span>
                                </li>
                                <li>
                                    <span className="text-lg font-bold leading-8">الأمانة</span>
                                    <span className="text-lg leading-8">
                                        : تُفصح مؤسسة الخير بشكل دوري عن كافة أنشطتها المالية
                                        والإدارية للجهات المعنية.
                                    </span>
                                </li>
                                <li>
                                    <span className="text-lg font-bold leading-8">
                                        الكفاءة والإبداع
                                    </span>
                                    <span className="text-lg leading-8">
                                        : نحن في منافسة مستمرة مع أنفسنا لأجل تحسين أنشطتنا الخيرية
                                        وتقديمها بأعلى جودة وأقل تكلفة بما يعود بأكبر فائدة على
                                        المستفيدين.
                                    </span>
                                </li>
                                <li>
                                    <span className="text-lg font-bold leading-8">الحيادية</span>
                                    <span className="text-lg leading-8">
                                        : نقدم خدماتنا الانسانية للجميع دون انحياز أو تمييز.
                                    </span>
                                </li>
                                <li>
                                    <span className="text-lg font-bold leading-8">
                                        التعاون والشراكة
                                    </span>
                                    <span className="text-lg leading-8">
                                        : نؤمن أن تعاونا وتكاملنا في الميدان الإنساني هو السبيل نحو
                                        عالم أفضل، معًا نُغير واقع المحتاجين.
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VisionAndMessage